import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicTextArea, BaasicButton } from 'core/components';

function FacilityOrderTemplateNewFlowPortalNoteModalTemplate({ facilityOrderTemplateNewFlowPortalNoteModalStore, t }) {
    const {
        form,
        modalParams,
        showWarningMessage
    } = facilityOrderTemplateNewFlowPortalNoteModalStore;

    const onKeyDown = (e) => {
        if (e.keyCode == 13) {
            e.preventDefault();
            form.onSubmit(e);
        }
    }

    return (
        <section className='w--400--px u-mar--top--med'>
            {
                showWarningMessage &&
                <div className="message message--note message--med u-mar--bottom--xsml">
                    <p>If you did not yet apply the changes to the template, please go back and apply them before proceeding.</p>
                </div>
            }
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('portalNote')} onKeyDown={onKeyDown} isFocus={true} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    disabled={form.submitting || form.validating}
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Submit"
                    className='btn btn--med btn--primary'
                />
            </div>
        </section>
    )
}

FacilityOrderTemplateNewFlowPortalNoteModalTemplate.propTypes = {
    facilityOrderTemplateNewFlowPortalNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateNewFlowPortalNoteModalTemplate);
